import type { SettingsPayload } from '@api/me/settings'

import { useSettingsStore } from '@stores/settings'
import { useReferralStore } from '@stores/referral'

import { useReferralDataApi } from '@api/referral/referral-data.hook'
import { useSettingsApi } from '@api/me/settings'
import { useAppBrand } from '@composables/tools/app-brand.hook'

import { defineNuxtRouteMiddleware, navigateTo } from '#app'

export default defineNuxtRouteMiddleware(async () => {
  const { isSmartestMinds } = useAppBrand()

  if (isSmartestMinds) return navigateTo('/')

  const settingsStore = useSettingsStore()
  const referralStore = useReferralStore()

  const { fetchReferralData } = useReferralDataApi()
  const fetchingReferralData = fetchReferralData()

  await settingsStore.ensure()

  const settingsToReset: SettingsPayload[] = []
  const isCreditsCelebration = settingsStore.isShowNewReferralCredits

  if (settingsStore.isShowNewReferralProgram) {
    settingsToReset.push({ key: 'show_new_referral_program', value: false })
  }

  if (isCreditsCelebration) {
    referralStore.setCreditsAnimation(true)
    referralStore.setBalanceAnimation(true)
    settingsToReset.push({ key: 'show_new_referral_credits', value: false })
  }

  void fetchingReferralData.then(() => {
    if (isCreditsCelebration && referralStore.isLoaded) {
      settingsToReset.push({ key: 'referral_seen_balance', value: referralStore.getBalance })
    }

    if (settingsToReset.length) {
      void useSettingsApi().postMany(settingsToReset, {
        onSuccess: () => {
          void settingsStore.ensure({ force: true })
        },
      })
    }
  })
})
